import { Component } from "@angular/core";
import { SelectedComponentEnum } from "@edp-models/edp-payment-agreement.model";
import { EdpPaymentAgreementService } from "@edp-services/edp-payment-agreement.service";
import { EdpSteperService } from "@edp-services/edp-steper.service";


@Component({
    selector: "no-associated-email",
    templateUrl: "./no-associated-email.component.html",
    styleUrls: ["./no-associated-email.component.scss"],
})
export class NoAssociatedEmailComponent {

    constructor (
        public steperService: EdpSteperService,
        private edpPaymentAgreementService: EdpPaymentAgreementService,
    ) { }

    public close() {
        this.steperService.setActiveStep(1);
        this.edpPaymentAgreementService.setSelectedComponent(SelectedComponentEnum.PERSONAL);
    }
    
}